export const availableLanguages = ['en', 'de', 'es', 'fr'] as const;

export const languageNames: Record<string, string> = {
  en: 'English',
  de: 'Deutsch',
  es: 'Español',
  fr: 'Français',
};

export const languageCountryCodes: Record<string, string> = {
  en: 'US',
  de: 'DE',
  es: 'ES',
  fr: 'FR',
};
